// @ts-nocheck -- staged migration: add explicit types before removing this directive.
import { Amplify } from "aws-amplify";

// Amplify accepts any URL in this array, but a given redirect only actually
// works once it's also registered on the Cognito user pool client's
// callbackUrls/logoutUrls (see infra/lib/kanalearn-auth-stack.ts).
// kanalearn.teqseq.com/admin.kanalearn.teqseq.com were removed once the
// domain cutover was confirmed - both now only 301-redirect to their
// nihongotech.teqseq.com equivalent. kanalearn.org/www.kanalearn.org (a
// separate legacy domain) and kanalearn-dev.teqseq.com (the dev
// environment) are untouched - out of scope for this rename.
const siteUrls = [
    "http://localhost:3000/",
    "https://nihongotech.teqseq.com/",
    "https://admin.nihongotech.teqseq.com/",
    "https://kanalearn.org/",
    "https://www.kanalearn.org/",
    "https://kanalearn-dev.teqseq.com/",
];

Amplify.configure({
    Auth: {
        Cognito: {
            userPoolId: process.env.REACT_APP_COGNITO_USER_POOL_ID,
            userPoolClientId: process.env.REACT_APP_COGNITO_USER_POOL_CLIENT_ID,
            identityPoolId: process.env.REACT_APP_COGNITO_IDENTITY_POOL_ID,
            loginWith: {
                oauth: {
                    domain: process.env.REACT_APP_COGNITO_DOMAIN,
                    scopes: ["email", "openid", "profile", "aws.cognito.signin.user.admin"],
                    redirectSignIn: siteUrls,
                    redirectSignOut: siteUrls,
                    responseType: "code",
                },
            },
        },
    },
});
